import { InitialState } from "./interface/initialType";
export const initialValue: InitialState = {
  width: 280,
  collapsed: false,
};
